import produce from "immer";

const defaultState = {
    item: null,
    error: null
};

export default function(state = defaultState, action) {
    switch (action.type) {
        case 'FETCH_REWARD_CLAIM_OPTIONS':
            return defaultState;
        case 'REWARD_CLAIM_OPTIONS_FETCHED':
            return produce(state, draft => {
                draft.item = {
                    expired: action.rewardClaimOptions.expired,
                    stockLeft: action.rewardClaimOptions.stockLeft,
                    amountAvailableForUser: action.rewardClaimOptions.amountAvailableForUser,
                    singleClaim: action.rewardClaimOptions.singleClaim,
                    showRewardClaimedDescription: action.rewardClaimOptions.showRewardClaimedDescription,
                    integratorType: action.rewardClaimOptions.integratorType,
                    url: action.rewardClaimOptions.url,
                    redirectUrlButtonVisible: action.rewardClaimOptions.redirectUrlButtonVisible
                }
            });
        case 'REWARD_CLAIM_OPTIONS_NOT_FOUND':
            return produce(state, draft => {
                draft.item = null;
                draft.error = "REWARD_CLAIM_OPTIONS_NOT_FOUND";
            });
        case 'REWARD_NOT_ACTIVE':
            return produce(state, draft => {
                draft.item.expired = true;
            });
        case 'REWARD_OUT_OF_STOCK':
            return produce(state, draft => {
                draft.item.stockLeft = false;
            });
        default:
            return state;
    }
}